/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTimeOffUpdates} from '../api'

 export const useQueryGetTimeOffUpdates = createReactQueryHook('getTimeOffUpdates', getTimeOffUpdates)
